export enum FleetSubMenuUrl {
	ANALYSIS = '/fleet/analysis',
	OVERVIEW = '/fleet/overview',
	TELEMETRY = '/fleet/telemetry',
	TECHNICAL_DATA = '/fleet/technical-data',
	STATS = '/fleet/stats',
	DETAILS = '/fleet/details',
	VEHICLE_HISTORY = '/fleet/vehicle-history',
}
